import React, { useEffect, useState } from 'react'
import { Button, Select, TextInput } from 'components/Form'
import { ConfirmationModal, Modal, SimpleTable, Tooltip } from 'components/Ui'
import { getApiData, deleteApiRecord, createApiRecord, updateApiRecord } from 'services/SftpConfigurationService'
import { Field, Form, Formik } from 'formik'
import { AiOutlinePlus } from 'react-icons/ai'
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi'
import { Success } from 'utils/alerts'
import * as Yup from 'yup'
import { connectorsOptions } from 'utils/options'

const validationSchema = Yup.object().shape({
    name: Yup.string().required('company name field is required'),
})

export default function SftpConfigurationTabView({ integrationData, record }) {
    const [data, setData] = useState([])
    const [selectedData, setSelectedData] = useState()
    const [open, setOpen] = useState(false)

    useEffect(() => {
        if (record) {
            getData({ company: record?.company?.id, customer: record?.id })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [record])

    const getData = data => {
        getApiData(data)
            .then(response => {
                if (response.data) {
                    setData(response.data?.results)
                }
            })
            .catch(error => console.log('Error fetching order type data: ', error))
    }

    const handleDelete = id => {
        deleteApiRecord(id)
            .then(() => {
                Success('Deleted Successfully!')
                getData({
                    company: record?.company?.id,
                    customer: record?.id,
                })
            })
            .catch(error => console.log('Error: ', error))
    }

    const handleSubmit = data => {
        if (selectedData?.id) {
            updateApiRecord(selectedData?.id, data)
                .then(() => {
                    getData({ company: record?.company?.id, customer: record?.id })
                    Success('Updated Successfully!')
                    setOpen(false)
                    setSelectedData()
                })
                .catch(error => console.log('Error: ', error))
        } else {
            createApiRecord(data)
                .then(() => {
                    getData({ company: record?.company?.id, customer: record?.id })
                    Success('Created Successfully!')
                    setOpen(false)
                    setSelectedData()
                })
                .catch(error => console.log('Error: ', error))
        }
    }

    return (
        <div>
            <div className="flex items-center justify-end mb-4">
                <Button
                    className="text-white border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                    onClick={() => setOpen(true)}
                >
                    <AiOutlinePlus size={20} /> Add New
                </Button>
            </div>
            <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                <SimpleTable>
                    <thead>
                        <SimpleTable.TR>
                            <SimpleTable.TH>Name</SimpleTable.TH>
                            <SimpleTable.TH>Company</SimpleTable.TH>
                            <SimpleTable.TH>Customer</SimpleTable.TH>
                            <SimpleTable.TH>Host</SimpleTable.TH>
                            <SimpleTable.TH>Port</SimpleTable.TH>
                            <SimpleTable.TH>Direction</SimpleTable.TH>
                            <SimpleTable.TH>Remote Path</SimpleTable.TH>
                            <SimpleTable.TH>Action</SimpleTable.TH>
                        </SimpleTable.TR>
                    </thead>
                    <tbody>
                        {(data || [])?.map((row, index) => (
                            <SimpleTable.TR key={`row-${index}`}>
                                <SimpleTable.TD>{row?.name}</SimpleTable.TD>
                                <SimpleTable.TD>{row.company_code}</SimpleTable.TD>
                                <SimpleTable.TD>{row?.customer_code}</SimpleTable.TD>
                                <SimpleTable.TD>{row?.host}</SimpleTable.TD>
                                <SimpleTable.TD>{row?.port}</SimpleTable.TD>
                                <SimpleTable.TD>{row?.direction}</SimpleTable.TD>
                                <SimpleTable.TD>{row?.remote_path}</SimpleTable.TD>
                                <SimpleTable.TD>
                                    <div className="flex items-center justify-center gap-3">
                                        {/* {checkPermission('order-type', 'edit') ? ( */}
                                        <Tooltip title={'Edit'}>
                                            <span
                                                onClick={() => {
                                                    setSelectedData(row)
                                                    setOpen(true)
                                                }}
                                                className="hover:text-primary"
                                            >
                                                <HiOutlinePencil size={20} />
                                            </span>
                                        </Tooltip>
                                        {/* ) : null} */}
                                        {/* {checkPermission('order-type', 'delete') ? ( */}
                                        <Tooltip title={'Delete'}>
                                            <ConfirmationModal
                                                message={'Are you sure you want to delete this record!'}
                                                onConfirm={() => handleDelete(row.id)}
                                            >
                                                <span className="hover:text-danger">
                                                    <HiOutlineTrash size={20} />
                                                </span>
                                            </ConfirmationModal>
                                        </Tooltip>
                                        {/* ) : null} */}
                                    </div>
                                </SimpleTable.TD>
                            </SimpleTable.TR>
                        ))}
                    </tbody>
                </SimpleTable>
            </div>
            <Modal
                show={open}
                maxWidth="4xl"
                onClose={() => {
                    setOpen(false)
                    setSelectedData()
                }}
            >
                <div className="flex flex-col gap-1 m-3">
                    <h2 className="font-semibold text-black text-title-md">
                        {selectedData ? 'Update SFTP Configuration' : 'Add New SFTP Configuration'}
                    </h2>
                </div>
                <div className="flex flex-col items-center">
                    <div className="w-full bg-white border rounded-sm overflow-auto max-h-150 border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                        <div className="flex flex-col gap-3 p-6">
                            <Formik
                                initialValues={
                                    selectedData
                                        ? selectedData
                                        : {
                                              integration: '',
                                              name: '',
                                              direction: 'both',
                                              host: '',
                                              port: '',
                                              username: '',
                                              password_encrypted: '',
                                              private_key_encrypted: '',
                                              remote_path: '',
                                              file_pattern: '',
                                              connectors: [],
                                          }
                                }
                                validationSchema={validationSchema}
                                onSubmit={values => {
                                    handleSubmit(values)
                                }}
                            >
                                {({ values, touched, errors }) => (
                                    <Form>
                                        <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-4">
                                            <Field name="name">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Name"
                                                        name="name"
                                                        error={errors.name && touched.name}
                                                        message={errors.name}
                                                        value={values?.name}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="integration">
                                                {({ field, form }) => (
                                                    <Select
                                                        id="integration"
                                                        name="integration"
                                                        label="Integration"
                                                        placeholder="Integration"
                                                        className="md:col-span-2"
                                                        value={values?.integration}
                                                        options={integrationData}
                                                        onChange={e => {
                                                            const integration = integrationData?.find(
                                                                i => i?.value?.toString() === e.target.value
                                                            )
                                                            form.setFieldValue(field.name, e.target.value)
                                                            form.setFieldValue('host', integration?.config?.host)
                                                            form.setFieldValue('port', integration?.config?.port)
                                                        }}
                                                        error={touched.integration && errors.integration}
                                                        message={errors.integration}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="direction">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Direction"
                                                        name="direction"
                                                        disabled
                                                        error={errors.direction && touched.direction}
                                                        message={errors.direction}
                                                        value={values?.direction}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="connectors">
                                                {({ field, form }) => (
                                                    <Select
                                                        id="connectors"
                                                        name="connectors"
                                                        label="Connectors"
                                                        placeholder="Select"
                                                        className="md:col-span-2"
                                                        value={values?.connectors ?? []}
                                                        options={connectorsOptions}
                                                        onChange={e => form.setFieldValue(field.name, e)}
                                                        error={touched.connectors && errors.connectors}
                                                        message={errors.connectors}
                                                        multiple={true}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="host">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Host"
                                                        name="host"
                                                        disabled
                                                        error={errors.host && touched.host}
                                                        message={errors.host}
                                                        value={values?.host}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="port">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Port"
                                                        name="port"
                                                        disabled
                                                        error={errors.port && touched.port}
                                                        message={errors.port}
                                                        value={values?.port}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="username">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Username"
                                                        name="username"
                                                        error={errors.username && touched.username}
                                                        message={errors.username}
                                                        value={values?.username}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="password_encrypted">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        password={true}
                                                        className="md:col-span-2"
                                                        label="Encrypted Password"
                                                        name="password_encrypted"
                                                        error={errors.password_encrypted && touched.password_encrypted}
                                                        message={errors.password_encrypted}
                                                        value={values?.password_encrypted}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            {/* <Field name="private_key_encrypted">
                                                                                    {({ field, form }) => (
                                                                                        <TextInput
                                                                                            type="text"
                                                                                            className="md:col-span-2"
                                                                                            label="Encrypted Private Key"
                                                                                            name="private_key_encrypted"
                                                                                            error={errors.private_key_encrypted && touched.private_key_encrypted}
                                                                                            message={errors.private_key_encrypted}
                                                                                            value={values?.private_key_encrypted}
                                                                                            onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                                                        />
                                                                                    )}
                                                                                </Field>
                                                                                <Field name="remote_path">
                                                                                    {({ field, form }) => (
                                                                                        <TextInput
                                                                                            type="text"
                                                                                            className="md:col-span-2"
                                                                                            label="Remote Path"
                                                                                            name="remote_path"
                                                                                            error={errors.remote_path && touched.remote_path}
                                                                                            message={errors.remote_path}
                                                                                            value={values?.remote_path}
                                                                                            onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                                                        />
                                                                                    )}
                                                                                </Field>
                                                                                <Field name="file_pattern">
                                                                                    {({ field, form }) => (
                                                                                        <TextInput
                                                                                            type="text"
                                                                                            className="md:col-span-2"
                                                                                            label="File Pattern"
                                                                                            name="file_pattern"
                                                                                            error={errors.file_pattern && touched.file_pattern}
                                                                                            message={errors.file_pattern}
                                                                                            value={values?.file_pattern}
                                                                                            onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                                                        />
                                                                                    )}
                                                                                </Field> */}
                                        </div>
                                        <div className="flex items-center justify-end gap-4 mt-3">
                                            <Button
                                                className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                                type="button"
                                                onClick={() => {
                                                    setOpen(false)
                                                    setSelectedData()
                                                }}
                                            >
                                                Discard
                                            </Button>
                                            <Button
                                                type="submit"
                                                className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                            >
                                                Save
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
